import cx from 'classnames';
import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
var classPrefix = 'pen-list-item';
var defaultProps = {};
export var ListItem = function ListItem(p) {
  var _cx;

  var _a;

  var props = mergeProps(defaultProps, p);
  var clickable = (_a = props.clickable) !== null && _a !== void 0 ? _a : Boolean(props.onClick);
  var arrow = props.arrow === undefined ? clickable : props.arrow;
  var content = /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-content"
  }, props.prefix && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-content-prefix"
  }, props.prefix), /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix + "-content-main")
  }, props.title && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-title"
  }, props.title), props.children, props.description && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-description"
  }, props.description)), props.extra && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-content-extra"
  }, props.extra), arrow && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-content-arrow"
  }, arrow === true ? /*#__PURE__*/React.createElement(RightOutlined, null) : arrow));
  return withNativeProps(props, /*#__PURE__*/React.createElement(clickable ? 'a' : 'div', {
    className: cx(classPrefix, (_cx = {}, _cx['pen-plain-anchor'] = clickable, _cx[classPrefix + "-disabled"] = Boolean(props.disabled), _cx)),
    onClick: props.disabled ? undefined : props.onClick
  }, content));
};